import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigurationService } from "./../services/configuration.service"
import { DomSanitizer } from '@angular/platform-browser';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { DataManipulateService } from './data-manipulate.service';

export interface RESPONSE {
  errorDescription: string;
  errorCode: string;
  Data: any;
}

@Injectable({
  providedIn: 'root'
})
export class ApiRequestsService {
  public readonly NO_ERROR = '000000';
  private readonly UNAUTHORISED_TOKEN = '999999';
  private readonly API_MAX_RETRY_LIMIT_EXCEEDED = '555555'
  public readonly API_BREAK_ERROR = '888888'
  private unAuthorisedHandlerFunction: CallableFunction | null = null;
  private retakeCount = 2;
  public networkAvailableFlag: boolean = true;
  private concurrentRequestsInProgress = 0;
  private token = '';
  public BaseURL = 'https://iotdemo.viotalworks.com/'; //'http://localhost:3009/'
  // public BaseURL = 'http://localhost:3009/'


  constructor(private HttpClient: HttpClient, private router: Router) { }


  get ConcurrentRequestsInProgress() {
    return this.concurrentRequestsInProgress;
  }


  private generateHeaderForAPIRequest = () => {
    return new HttpHeaders({
      authorization: 'Bearer ' + this.getTokenValue(),
      authfor: 'M',
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "X-Requested-With, content-type",
      "Content-Type": "application/json"

    });
  };



  private generateCriteriaParameters = (method: 'GET' | 'POST', params: { [key: string]: any } | undefined) => {

    let HttpParams = this.generateCriteriaParameters_withoutEncryption(method, params);

    return HttpParams;
  }

  private generateCriteriaParameters_withoutEncryption = (method: 'GET' | 'POST', params: { [key: string]: any } | undefined) => {
    let httpParams;

    if (!params || typeof params !== 'object') return undefined;

    if (method == 'GET') {
      httpParams = new HttpParams();
      httpParams = httpParams.append('criteria', JSON.stringify(params));
    } else if (method == 'POST') {
      httpParams = { criteria: params }
    }
    return httpParams;

  }

  // private generateCriteriaParameters_WithEncryption = (method: 'GET' | 'POST', params: { [key: string]: any } | undefined, algo: algoType = this.encr.defaultEncryptionAlgorithm) => {
  //   let httpParams;

  //   if (!params || typeof params !== 'object') return undefined;

  //   const encryptedParams = this.encr.encryptData(JSON.stringify(params), algo);

  //   if (method == 'GET') {
  //     httpParams = new HttpParams();
  //     const obj = algo == 'RSA' ? { rx: encryptedParams } : { ox: encryptedParams };
  //     const objStr = JSON.stringify(obj);
  //     httpParams = httpParams.append('criteria', objStr);
  //   } else if (method == 'POST') {

  //     httpParams = algo == 'RSA' ? { criteria: { rx: encryptedParams } } : { criteria: { ox: encryptedParams } }
  //   }
  //   return httpParams;

  // }

  getApiCall = (url: string, parameters: any = null): Observable<RESPONSE> => {
    let httpHeaders = this.generateHeaderForAPIRequest();
    let httpParams: HttpParams | undefined | { criteria: any } = this.generateCriteriaParameters('GET', parameters);

    return this.HttpClient.get<RESPONSE>(this.BaseURL + url, {
      params: httpParams,
      headers: httpHeaders
    });
  };

  private httpPostAPICall = async (url: string, params: { [key: string]: any } | undefined = undefined): Promise<RESPONSE> => {

    return new Promise((resolve, reject) => {
      let httpHeaders = this.generateHeaderForAPIRequest();
      let httpParams: HttpParams | undefined | { criteria: any } = this.generateCriteriaParameters('POST', params);

      this.concurrentRequestsInProgress++;
      const httpcall = this.HttpClient.post<RESPONSE>(this.BaseURL + url, httpParams, {
        headers: httpHeaders,
      }).subscribe({
        next: (res: RESPONSE) => { this.concurrentRequestsInProgress--; resolve(res); return; },
        error: (err: any) => {
          this.networkAvailableFlag = false;
          this.concurrentRequestsInProgress--;
          resolve({ errorCode: this.API_BREAK_ERROR, errorDescription: 'Api Break', Data: err });

          // this.refreshNetworkPermission().then(res => {
          //   const errDescr = `API Break with Network status` + (res.connected ? ` Is Connected` : `Is not Connected`);
          //   return;
          // });

        },
        complete: () => {
          httpcall.unsubscribe();
          return;
        }
      })
    })
  }

  private httpGetAPICall = async (url: string, params: { [key: string]: any } | undefined = undefined): Promise<RESPONSE> => {
    return new Promise((resolve, reject) => {
      let httpHeaders = this.generateHeaderForAPIRequest();
      let httpParams: HttpParams | undefined | { criteria: any } = this.generateCriteriaParameters('GET', params);

      this.concurrentRequestsInProgress++;
      const httpcall = this.HttpClient.get<RESPONSE>(this.BaseURL + url, {
        params: httpParams,
        headers: httpHeaders,
      }).subscribe({
        next: (res: RESPONSE) => { this.concurrentRequestsInProgress--; resolve(res); return },
        error: (err: any) => {
          this.networkAvailableFlag = false;
          this.concurrentRequestsInProgress--;
          resolve({ errorCode: this.API_BREAK_ERROR, errorDescription: 'Api Break', Data: err });

        },
        complete: () => {
          httpcall.unsubscribe();
          return;
        }
      })
    })
  }

  postAPICallWithPromise = async (url: string, params: { [key: string]: any } | undefined = undefined): Promise<RESPONSE> => {

    let httpPostAPIResult: RESPONSE = { errorCode: this.API_MAX_RETRY_LIMIT_EXCEEDED, errorDescription: "Count Exceeded", Data: {} };
    let count = 0;

    while (count < 2) {
      let ntkUsed = this.getTokenValue();
      httpPostAPIResult = await this.httpPostAPICall(url, params);
      let { errorCode, errorDescription, Data } = httpPostAPIResult;
      console.log('Response Data Post API Call:', JSON.stringify(Data));

      httpPostAPIResult['Data'] = Data;

      if (errorCode == this.UNAUTHORISED_TOKEN) {
        console.log(`PostAPICallWithPromise : AuthError: [${url}] - retry count = [${count}]`);
        count++;
        if (Data['ntk']) {
          this.updateOrSetTokenValue(Data['ntk']);
          continue;
        } else if (ntkUsed !== this.getTokenValue()) {
          continue;
        } else {
          console.error('logout no ntk');
          this.router.navigateByUrl('/login');
          // if (this.unAuthorisedHandlerFunction) {
          //   console.error('Going to unAuthorizedHandler Function...');
          //   this.unAuthorisedHandlerFunction(true);
          // } else {
          //   console.error('Unauthorized handler function not defined. Not sure what to do.');
          // }
          break;
        }
      } else {
        break;
      }
    }


    return httpPostAPIResult;
  }


  getAPICallWithPromise = async (url: string, params: any = undefined): Promise<RESPONSE> => {

    let httpGetAPIResult: RESPONSE = { errorCode: this.API_MAX_RETRY_LIMIT_EXCEEDED, errorDescription: "Count Exceeded", Data: {} };
    let count = 0;

    while (count < 2) {
      let ntkUsed = this.getTokenValue();
      httpGetAPIResult = await this.httpGetAPICall(url, params);
      let { errorCode, errorDescription, Data } = httpGetAPIResult;
      console.log(`Get URL : ${url}`);

      console.log('Response Data Post API Call:', JSON.stringify(Data));
      if (errorCode == this.NO_ERROR) {
        // Data = this.generateDecryptedResponseObject(Data, algo);
      }

      //const decryptData = this.generateDecryptedResponseObject(Data, algo);

      httpGetAPIResult['Data'] = Data;

      if (errorCode == this.UNAUTHORISED_TOKEN) {
        console.log(`getAPICallWithPromise: AuthError: [${url}] - retry count = [${count}]`);
        count++;
        if (Data['ntk']) {
          console.error('Received new ntk');
          this.updateOrSetTokenValue(Data['ntk']);
          continue;
        } else if (ntkUsed !== this.getTokenValue()) {
          console.error('ntk seems to be changed after used by this api call.');
          continue;
        } else {
          console.error('logout no ntk');
          if (this.unAuthorisedHandlerFunction) {
            console.error('Going to unAuthorizedHandler Function...');
            this.unAuthorisedHandlerFunction(true);
          } else {
            console.error('Unauthorized handler function not defined. Not sure what to do.');
          }
          break;
        }
      } else {
        break;
      }
    }


    return httpGetAPIResult;

  }


  // private refreshNetworkPermission = async () => {
  //   return await Network.getStatus();
  // }


  updateOrSetTokenValue = (newToken: string) => {
    this.token = newToken;
    localStorage.setItem("userToken", newToken)
  };

  getTokenValue = (): string => {
    return this.token;
  }



  setUnAutorisedHandler = (unAuthorisedHandler: CallableFunction): void => {
    this.unAuthorisedHandlerFunction = unAuthorisedHandler;
  }

  uploadFile = async (endPoint: string, imageBase64: string | File, params: any | undefined = undefined): Promise<RESPONSE> => {
    return new Promise(async (resolve, reject) => {

      let blob: any;
      let blobThumbnail: any;
      if (typeof imageBase64 == 'string') {
        const base64Response = await fetch(imageBase64);
        blob = await base64Response.blob();
      } else {
        blob = imageBase64;
      }

      const fd = new FormData();
      // //console.log('Image', imageBase64, blob, params, fileMimeType);

      fd.append('file', blob);
      if (params && typeof params === 'object') {
        fd.append('criteria', JSON.stringify(params));
      } else {
        fd.append('criteria', `${params}`);

      }

      const httpHeaders = new HttpHeaders({
        authorization: 'Bearer ' + this.getTokenValue(),
        authfor: 'M'
      });

      this.concurrentRequestsInProgress++;

      const httpcall = this.HttpClient.post<RESPONSE>(this.BaseURL + endPoint, fd, {
        headers: httpHeaders,
      }).subscribe({
        next: (res: RESPONSE) => {
          this.concurrentRequestsInProgress--;
          if (res['errorCode'] == this.UNAUTHORISED_TOKEN) {
            if (this.unAuthorisedHandlerFunction) {
              this.unAuthorisedHandlerFunction(true);
            }
          }

          let { errorCode, errorDescription, Data } = res;
          console.log('Response Data Post API Call:', JSON.stringify(Data));
          if (errorCode == this.NO_ERROR) {
            // Data = this.generateDecryptedResponseObject(Data, algo);
          }
          res['Data'] = Data;
          resolve(res);
          return;
        },
        error: (err: any) => {
          this.concurrentRequestsInProgress--;
          reject(err);
          return;
        },
        complete: () => {
          httpcall.unsubscribe();
          return;
        }
      })

    })
  }

  uploadFiles = async (endPoint: string, imageBase64: string | File, params: any | undefined = undefined): Promise<RESPONSE> => {
    return new Promise(async (resolve, reject) => {

      let blob: any;
      let blobThumbnail: any;
      if (typeof imageBase64 == 'string') {
        const base64Response = await fetch(imageBase64);
        blob = await base64Response.blob();
      } else {
        blob = imageBase64;
      }

      const thumbnailBlob = await this.compressImageToThumbnail(blob);

      console.log(`Original Image ${imageBase64}`);

      const fd = new FormData();
      // //console.log('Image', imageBase64, blob, params, fileMimeType);

      fd.append('files', blob);
      fd.append('files', thumbnailBlob);
      if (params && typeof params === 'object') {
        fd.append('criteria', JSON.stringify(params));
      } else {
        fd.append('criteria', `${params}`);

      }

      const httpHeaders = new HttpHeaders({
        authorization: 'Bearer ' + this.getTokenValue(),
        authfor: 'M'
      });

      this.concurrentRequestsInProgress++;

      const httpcall = this.HttpClient.post<RESPONSE>(this.BaseURL + endPoint, fd, {
        headers: httpHeaders,
      }).subscribe({
        next: (res: RESPONSE) => {
          this.concurrentRequestsInProgress--;
          if (res['errorCode'] == this.UNAUTHORISED_TOKEN) {
            if (this.unAuthorisedHandlerFunction) {
              this.unAuthorisedHandlerFunction(true);
            }
          }

          let { errorCode, errorDescription, Data } = res;
          console.log('Response Data Post API Call:', JSON.stringify(Data));
          if (errorCode == this.NO_ERROR) {
            // Data = this.generateDecryptedResponseObject(Data, algo);
          }
          res['Data'] = Data;

          resolve(res);
          return;
        },
        error: (err: any) => {
          this.concurrentRequestsInProgress--;
          reject(err);
          return;
        },
        complete: () => {
          httpcall.unsubscribe();
          return;
        }
      })

    })
  }

  compressImageToThumbnail = async (imageBlob: any) => {
    // const compressedFile: File = await imageCompression(imageBlob, { maxSizeMB: 100, maxWidthOrHeight: 90, useWebWorker: true });
    return '';
  }

}
